import { createErrorModel } from './error';

const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

const dedupeMessages = (messages) => {
  const seen = new Set();

  return messages.filter((message) => {
    if (seen.has(message)) {
      return false;
    }

    seen.add(message);
    return true;
  });
};

const flattenMessages = (value) => {
  if (typeof value === 'string') {
    return value ? [value] : [];
  }

  if (Array.isArray(value)) {
    return value.flatMap(flattenMessages);
  }

  if (isPlainObject(value)) {
    return Object.values(value).flatMap(flattenMessages);
  }

  return [];
};

const getPayload = (errorOrResponse) => {
  if (errorOrResponse?.response?.data !== undefined) {
    return errorOrResponse.response.data;
  }

  if (errorOrResponse?.data !== undefined) {
    return errorOrResponse.data;
  }

  if (isPlainObject(errorOrResponse)) {
    return errorOrResponse;
  }

  return null;
};

const isValidAlert = (alert) => {
  return isPlainObject(alert) && typeof alert.message === 'string';
};

export const getApiAlerts = (errorOrResponse) => {
  const payload = getPayload(errorOrResponse);
  const alerts = payload?.alerts;

  if (!Array.isArray(alerts)) {
    return [];
  }

  return alerts.filter(isValidAlert);
};

export const getLocalApiMessages = (errorOrResponse) => {
  const payload = getPayload(errorOrResponse);

  return dedupeMessages([
    ...flattenMessages(payload?.errors),
    ...flattenMessages(payload?.messages),
  ]);
};

export const getFirstFlashAlert = (errorOrResponse) => {
  return (
    getApiAlerts(errorOrResponse).find((alert) => alert.flash === true) || null
  );
};

export const normalizeApiFeedback = (errorOrResponse) => {
  return {
    alerts: getApiAlerts(errorOrResponse),
    localMessages: getLocalApiMessages(errorOrResponse),
    flashAlert: getFirstFlashAlert(errorOrResponse),
    fallbackError: createErrorModel(errorOrResponse),
  };
};
